import { render } from "./ActivitiesMassMarkAsDone.vue?vue&type=template&id=661ebb16"
import script from "./ActivitiesMassMarkAsDone.vue?vue&type=script&lang=js"
export * from "./ActivitiesMassMarkAsDone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__